import loadTranslations from './load-translations';

export default {
  loadTranslations,
};
